export const name = "KLL_QUANTILES.MERGE_POINT_FLOAT64";
export const summary = `Merges \`FLOAT64\`-initialized KLL sketches into a new sketch, and then gets a specific quantile from the new sketch.`;
export const reference = `
## KLL_QUANTILES.MERGE_POINT_FLOAT64

Merges \`FLOAT64\`-initialized KLL sketches into a new sketch, and then gets a specific quantile from the new sketch.

\`\`\`
KLL_QUANTILES.MERGE_POINT_FLOAT64(sketch, phi)
\`\`\`

### Description

Like \`KLL_QUANTILES.MERGE_POINT_INT64\`, but accepts KLL sketches initialized on data of type\`FLOAT64\`.

\`KLL_QUANTILES.MERGE_POINT_FLOAT64\` orders values according to the GoogleSQL floating point sort order. For example, \`NaN\`orders before \`‑inf\`.


### Supported Argument Types

- \`sketch\`: \`BYTES\` KLL sketch initialized on\`FLOAT64\` data type
- \`phi\`: \`FLOAT64\` between 0 and 1


### Return Type

\`FLOAT64\`




source: https://cloud.google.com/bigquery/docs/reference/standard-sql/kll_functions
`;
